export default function readingProgress() {
    const article = document.querySelector('.gh-article');
    const indicator = document.querySelector('[data-reading-progress]');

    if (!article || !indicator) {
        return;
    }

    const updateProgress = () => {
        const articleTop = article.getBoundingClientRect().top + window.scrollY;
        const readableHeight = Math.max(article.offsetHeight - window.innerHeight, 1);
        const progress = Math.min(Math.max((window.scrollY - articleTop) / readableHeight, 0), 1);

        indicator.style.transform = `scaleX(${progress})`;
    };

    window.addEventListener('scroll', updateProgress, {passive: true});
    window.addEventListener('resize', updateProgress);
    updateProgress();
}
